var map = {
	"./1.png": "c37a",
	"./10.png": "f112",
	"./2.png": "3ec1",
	"./26.png": "d47b",
	"./3.png": "2596",
	"./30.png": "e5d5",
	"./4.png": "b0bb",
	"./40.png": "1f3e",
	"./41.png": "01df",
	"./5.png": "14d6",
	"./6.png": "7f27",
	"./7.png": "a7c8",
	"./8.png": "c8c8",
	"./9.png": "7de3",
	"./aop.png": "53e2",
	"./janssen.png": "9277",
	"./roche.png": "a814",
	"./teva.png": "e8e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad71";